export default __webpack_public_path__ + "static/media/char_head_prem_017.ed4f6fe8.png";